import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Países de serviço',
    path: '/commercial/servicesCountries',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
